import { Tab, Tabs } from '@mui/material';
import { Location, UnregisterCallback } from 'history';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link as RouterLink, RouteComponentProps } from 'react-router-dom';

import { RequireRole } from 'app/components/require-role';
import { Role } from 'app/constants/role';
import { MenuItemData } from 'app/model/menu-item';
import { RootState } from 'app/store';

import { selectRoles } from '../auth/auth.slice';

interface TopNavState {
    topNavVal: number | false;
}

const topMenu: MenuItemData[] = [
    {
        name: 'Home',
        routerLink: '/',
    },
    {
        name: 'SEAM',
        routerLink: '/seam',
        role: Role.SEAM_REQUESTS,
    },
    {
        name: 'CRIS',
        routerLink: '/cris',
    },
    {
        name: 'QA',
        routerLink: '/qa',
        role: Role.QA_MANAGER,
    },
    {
        name: 'Explore',
        routerLink: '/explore',
    },
    {
        name: 'Crowd',
        routerLink: '/crowd',
        role: Role.USER,
    },
];

interface TopNavProps extends RouteComponentProps {
    // redux Props
    currentRoles: Record<string, boolean>;
}

class TopNav extends React.Component<TopNavProps, TopNavState> {
    private unsubscribeHistory?: UnregisterCallback;

    public constructor(props: Readonly<TopNavProps> | TopNavProps) {
        super(props);

        this.state = {
            topNavVal: TopNav.parseLocation(this.props.history.location),
        };
    }

    public componentDidMount() {
        this.unsubscribeHistory = this.props.history.listen((location) => {
            this.setState({ topNavVal: TopNav.parseLocation(location) });
        });
    }

    public componentWillUnmount() {
        if (this.unsubscribeHistory) {
            this.unsubscribeHistory();
        }
    }

    public render() {
        return (
            <Tabs
                value={this.state.topNavVal}
                aria-label='main navigation'
                indicatorColor='secondary'
                textColor='inherit'
            >
                {topMenu.map((value, index) => (
                    // cant USE value on <Tab> it gets ignored becuase its wrapped in RequireRole, so reverts to index
                    <RequireRole roles={value.role} key={index} insufficientAccessRender={<span />}>
                        <Tab
                            label={value.name}
                            id={`top-nav-tab-${index}`}
                            key={index}
                            disabled={value.disabled}
                            component={RouterLink}
                            to={value.routerLink || '/'}
                            value={index}
                        />
                    </RequireRole>
                ))}
            </Tabs>
        );
    }

    private static parseLocation(location: Location): number | false {
        for (let i = 1; i < topMenu.length; i++) {
            if (location.pathname.startsWith(topMenu[i].routerLink || '/')) {
                return i;
            }
        }

        if ('/' === location.pathname) {
            return 0;
        }

        return false;
    }
}

const mapStateToProps = (state: RootState) => ({
    currentRoles: selectRoles(state),
});

const connected = connect(mapStateToProps)(withRouter(TopNav));

export { connected as TopNav };
